import type { ProductGroupById } from '../contexts/ProductGroupsProvider';
import type { ResourceLibraryItemBase } from '../types/resourceLibraryItems';
import { PIMCORE_CONTENT_BASE_URL } from '../../../../../utils/Pimcore';

/**
 * Resolves a Pimcore PATH for the header background image.
 * Tries each associated product group, walking up parents, then returns fallbackPath.
 */
export function resolveHeaderBackgroundPath(
    item: ResourceLibraryItemBase | null,
    /** Mapping of product group IDs to product group data. */
    productGroupById: ProductGroupById,
    /** Optional Pimcore fallback PATH (not URL). */
    fallbackPath?: string
): string | undefined {
    const fallback = sanitizeFallbackPath(fallbackPath);
    if (!item) {
        return fallback;
    }
    // Try each associated product group in order
    for (const pgId of item.productGroupIds) {
        const group = productGroupById[pgId];
        const background = group?.backgroundImageUrl ?? group?.parent?.backgroundImageUrl;
        if (background) {
            return `${PIMCORE_CONTENT_BASE_URL}${background}`;
        }
    }

    return fallback;
}

function sanitizeFallbackPath(path: string | undefined): string | undefined {
    if (!path) {
        return undefined;
    }
    return path.startsWith(PIMCORE_CONTENT_BASE_URL) ? path : `${PIMCORE_CONTENT_BASE_URL}${path}`;
}
